import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "PGApplication";

export const verifyPGPaymentUrl = (rrr) =>
	`${baseUrl}/verify-payment?rrr=${rrr}`;
export const submitPGApplicationStepUrl = (step) => `${baseUrl}/step-${step}`;
export const getRefereeRatingOptionsUrl = () => `${baseUrl}/referee-ratings`;
export const getRefereeInfoUrl = (passCode) =>
	`${baseUrl}/referee-info?passCode=${passCode}`;
export const submitRefereeReviewUrl = () => `${baseUrl}/referee-review`;
export const getPGTrackingVerificationUrl = (rrr) =>
	`${baseUrl}/reprint?rrr=${rrr}`;
export const getPGTranscriptRequestUrl = (rrr) =>
	`${baseUrl}/transcript-request?rrr=${rrr}`;
export const getPGRefereeStatusUrl = (rrr) =>
	`${baseUrl}/referee-status?rrr=${rrr}`;
export const updatePGRefereeUrl = (refereeId) =>
	`${baseUrl}/update-referee?refereeId=${refereeId}`;
export const getRefereePrintOutUrl = (refereeEmail, applicantId) =>
	`${baseUrl}/referee-printout?refereeEmail=${refereeEmail}&applicantId=${applicantId}`;
export const getPGpplicationReportsUrl = (filter) =>
	`${baseUrl}/application-report?${generateUrlParams(filter)}`;
export const downloadPGpplicationReportsUrl = (filter) =>
	`${baseUrl}/download-report?${generateUrlParams(filter)}`;
